export const ACHIEVEMENTS = [

	{
		id: "primer_paso",
		titulo: "Primer Paso",
		descripcion:
			"Responde tu primera pregunta",

		icono: "🌱",

		condicion: (data) =>
			data.preguntas_respondidas >= 1
	},

	{
		id: "racha_5",
		titulo: "En Llamas",
		descripcion:
			"Consigue una racha de 5",

		icono: "🔥",

		condicion: (data) =>
			data.mejor_streak >= 5
	},

	{
		id: "nivel_10",
		titulo: "Despertar",
		descripcion:
			"Alcanza el nivel 10",

		icono: "⚡",

		condicion: (data) =>
			data.nivel >= 10
	},

	{
		id: "perfecto",
		titulo: "Mente Perfecta",
		descripcion:
			"Logra 100% precisión con mínimo 20 preguntas",

		icono: "🧠",

		condicion: (data) =>
			data.preguntas_respondidas >= 20 &&
			(
				data.preguntas_correctas /
				data.preguntas_respondidas
			) === 1
	},

	{
		id: "veterano",
		titulo: "Veterano",
		descripcion:
			"Responde 100 preguntas",

		icono: "👑",

		condicion: (data) =>
			data.preguntas_respondidas >= 100
	}
];